import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import Form from '../../components/CollapsesForm';

const CollapsesBar = ({ columns, onSubmit }) => {
  if (!columns) {
    return null;
  }

  const initialValues = Object.fromEntries(
    columns.selected.map(item => [item, true]),
  );

  return (
    <Formik onSubmit={onSubmit} initialValues={initialValues}>
      {({ submitForm }) => (
        <>
          <Form
            onSubmit={submitForm}
            columns={columns}
            itemsStyle={{ marginBottom: 0 }}
          />
        </>
      )}
    </Formik>
  );
};

CollapsesBar.propTypes = {
  columns: PropTypes.shape({
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
};

CollapsesBar.defaultProps = {
  columns: null,
};

export default CollapsesBar;
